import api from "!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../css-loader/dist/cjs.js??ref--14-1!../../../postcss-loader/dist/cjs.js??ref--14-2!./style.css";

var options = {"attributes":{"class":"dep-class"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};